import react, { useState, useEffect, useRef } from "react";
import {
  Input,
  TextArea,
  Select,
  SelectCountries,
  SelectMultiple,
  Switch,
} from "../../../../Layout/Forms/Form";

import { Table } from "react-bootstrap";
const Details = ({
  type,
  visible,
  handleChangeForm,
  form,
  generalInfo,
  isLoading,
}) => {
  const sectionSchedule = useRef(null);
  const [pageLoadedFinish, setPageLoadedFinish] = useState(false);
  // const [countryList, setCountryList] = useState([]);
  // const [typesVenues, setTypesVenues] = useState([]);
  // const [form, setForm] = useState({
  //     name: "",
  //     phone_country: "+351",
  //     phone_number: "",
  //     description: "",
  //     id_venues_type: "",

  // });

  // handler inputs
  const handleChangeInputs = (e) => {
    handleChangeForm({
      ...form.details,
      [e.target.name]: e.target.value,
    });
  };

  // const getFormInfo = async () => {
  //     let info = await NightspotRequests.getInfoFormNightspot();
  //     if(info.status){
  //         //console.log(info)
  //         setCountryList(info.data.listCountryContact);
  //         setTypesVenues(info.data.typesVenues);

  //     }
  // }

  // useEffect(() => {
  //     handleChangeForm(form);
  // }, [form])

  useEffect(() => {
    setPageLoadedFinish(true);
  }, []);

  useEffect(() => {
    if (pageLoadedFinish)
      sectionSchedule.current?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
  }, [form.details.schedule]);

  const seriaizeCountryList = () => {
    if (
      generalInfo &&
      generalInfo.listCountryContact &&
      generalInfo.listCountryContact.length > 0
    )
      return generalInfo.listCountryContact.map((item) => {
        return {
          label: item.name,
          value: item.phone_country,
          icon: item.icon,
        };
      });
  };

  const seriaizeTypesVenues = () => {
    if (
      generalInfo &&
      generalInfo.typesVenues &&
      generalInfo.typesVenues.length > 0
    )
      return generalInfo.typesVenues.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
  };

  const serializeTimeZone = () => {
    const timezones = [
      { label: "Europa/Lisboa", value: "+01:00" }, // Europe/Lisbon
      { label: "Europa/Londres", value: "00:00" }, // Europe/London
      { label: "Europa/Berlim", value: "+02:00" }, // Europe/Berlin
      { label: "Europa/Paris", value: "+02:00" }, // Europe/Paris
      { label: "Europa/Madrid", value: "+02:00" }, // Europe/Madrid
      { label: "América/Nova Iorque", value: "-04:00" }, // America/New_York
      { label: "América/São Paulo", value: "-03:00" }, // America/Sao_Paulo
      { label: "África/Joanesburgo", value: "+02:00" }, // Africa/Johannesburg
      { label: "África/Cairo", value: "+02:00" }, // Africa/Cairo
      { label: "Ásia/Tóquio", value: "+09:00" }, // Asia/Tokyo
      { label: "Ásia/Xangai", value: "+08:00" }, // Asia/Shanghai
      { label: "Oceânia/Sydney", value: "+11:00" }, // Australia/Sydney
      { label: "Oceânia/Auckland", value: "+13:00" }, // Pacific/Auckland
      { label: "Ásia/Dubai", value: "+04:00" }, // Asia/Dubai
      { label: "América/México", value: "-05:00" }, // America/Mexico_City
      { label: "América/Buenos Aires", value: "-03:00" }, // America/Argentina/Buenos_Aires
      { label: "América/Los Angeles", value: "-07:00" }, // America/Los_Angeles
      { label: "Europa/Moscovo", value: "+03:00" }, // Europe/Moscow
      { label: "Ásia/Calcutá", value: "+05:30" }, // Asia/Kolkata
      { label: "Ásia/Banguecoque", value: "+07:00" }, // Asia/Bangkok
      { label: "Ásia/Singapura", value: "+08:00" }, // Asia/Singapore
      { label: "Europa/Roma", value: "+02:00" }, // Europe/Rome
      { label: "Europa/Atenas", value: "+03:00" }, // Europe/Athens
      { label: "Europa/Amesterdão", value: "+02:00" }, // Europe/Amsterdam
      { label: "Europa/Bruxelas", value: "+02:00" }, // Europe/Brussels
      { label: "Europa/Estocolmo", value: "+02:00" }, // Europe/Stockholm
      { label: "Europa/Zurique", value: "+02:00" }, // Europe/Zurich
      { label: "América/Chicago", value: "-05:00" }, // America/Chicago
      { label: "América/Vancouver", value: "-07:00" }, // America/Vancouver
      { label: "Pacífico/Honolulu", value: "-10:00" }, // Pacific/Honolulu
      { label: "América/Panamá", value: "-05:00" }, // America/Panama
      { label: "Ásia/Hong Kong", value: "+08:00" }, // Asia/Hong_Kong
      { label: "Ásia/Kuala Lumpur", value: "+08:00" }, // Asia/Kuala_Lumpur
    ];

    return timezones;
  };

  const seriaizeTypesGenres = () => {
    if (
      generalInfo &&
      generalInfo.typesGenres &&
      generalInfo.typesGenres.length > 0
    )
      return generalInfo.typesGenres.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
  };

  const SerializaeHours = [
    {
      label: "16:00",
      value: "16:00",
    },
    {
      label: "17:00",
      value: "17:00",
    },
    {
      label: "18:00",
      value: "18:00",
    },
    {
      label: "19:00",
      value: "19:00",
    },
    {
      label: "20:00",
      value: "20:00",
    },
    {
      label: "21:00",
      value: "21:00",
    },
    {
      label: "22:00",
      value: "22:00",
    },
    {
      label: "23:00",
      value: "23:00",
    },
    {
      label: "00:00",
      value: "00:00",
    },
    {
      label: "01:00",
      value: "01:00",
    },
    {
      label: "02:00",
      value: "02:00",
    },
    {
      label: "03:00",
      value: "03:00",
    },
    {
      label: "04:00",
      value: "04:00",
    },
    {
      label: "05:00",
      value: "05:00",
    },
    {
      label: "06:00",
      value: "06:00",
    },
    {
      label: "07:00",
      value: "07:00",
    },
    {
      label: "08:00",
      value: "08:00",
    },
    {
      label: "09:00",
      value: "09:00",
    },
    {
      label: "10:00",
      value: "10:00",
    },
    {
      label: "11:00",
      value: "11:00",
    },
    {
      label: "12:00",
      value: "12:00",
    },
    {
      label: "13:00",
      value: "13:00",
    },
    {
      label: "14:00",
      value: "14:00",
    },
    {
      label: "15:00",
      value: "15:00",
    },
  ];

  return (
    <div style={{ display: !visible ? "none" : "block" }}>
      <div className="row" style={{ marginTop: "30px" }}>
        <div className="col-12 col-sm-4">
          <Input
            label="Nome"
            name="name"
            value={form.details.name}
            onPaste={(e) => { e.preventDefault(); handleChangeInputs({ target: { name: e.target.name, value: e.clipboardData.getData('Text') } }) }}
            onChange={(e) => handleChangeInputs(e)}
            errors={form.errors}
          />
        </div>
        <div className="col-2 col-sm-1">
          <SelectCountries
            label="&nbsp;"
            name="phone_country"
            value={form.details.phone_country}
            onChange={(e) => handleChangeInputs(e)}
            options={seriaizeCountryList()}
            errors={form.errors}
          />
        </div>
        <div className="col-5 col-sm-2">
          <Input
            label="Nº Telemóvel"
            name="phone_number"
            value={form.details.phone_number}
            onPaste={(e) => { e.preventDefault(); handleChangeInputs({ target: { name: e.target.name, value: e.clipboardData.getData('Text') } }) }}
            onChange={(e) => handleChangeInputs(e)}
            errors={form.errors}
          />
        </div>
        {type == "venue" ? (
          <div className="col-3 ">
            <Select
              label="Tipo"
              name="id_venues_type"
              value={form.details.id_venues_type}
              onChangeOption={(e) => handleChangeInputs(e)}
              options={seriaizeTypesVenues()}
              errors={form.errors}
            />
          </div>
        ) : null}

        <div className={type == "venue" ? "col-2" : "col-5"}>
          <Select
            label="Fuso Horário"
            name="timezone"
            value={form.details.timezone}
            onChangeOption={(e) => handleChangeInputs(e)}
            options={serializeTimeZone()}
            errors={form.errors}
          />
        </div>
      </div>
      <div className="row" style={{ marginTop: "30px" }}>
        <div className="col-12">
          <TextArea
            label="Descrição"
            name="description"
            value={form.details.description}
            onPaste={(e) => { e.preventDefault(); handleChangeInputs({ target: { name: e.target.name, value: e.clipboardData.getData('Text') } }) }}
            onChange={(e) => handleChangeInputs(e)}
            rows={5}
            errors={form.errors}
          />
        </div>
      </div>

      {/* <div className="row" style={{ marginTop: '30px' }}>
                <div className="col-6">

                    <SelectMultiple
                        options={seriaizeTypesGenres()}
                        value={form.details.ids_venues_genres || []}
                        name="ids_venues_genres"
                        onChange={(e) => handleChangeInputs(e)}
                        label="Venue genre"
                    />
                </div>
            </div> */}
      <div
        className="row"
        style={{
          marginTop: "30px",
          display: type == "organization" ? "none" : null,
        }}
      >
        <div className="col-12">
          <h4>Horário</h4>
          <Table striped bordered hover ref={sectionSchedule}>
            <thead>
              <tr>
                <th>Dia</th>
                <th>Abertura</th>
                <th>Fecho</th>
                <th>Encerrado</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Segunda-Feira</td>
                <td>
                  {!form.details.schedule.monday.isClosed && (
                    <Select
                      label=""
                      variant="simple-no-label"
                      className="form-control form-input simple"
                      name="start"
                      value={form.details.schedule.monday.start}
                      onChangeOption={(e) => {
                        handleChangeForm({
                          ...form.details,
                          schedule: {
                            ...form.details.schedule,
                            monday: {
                              ...form.details.schedule.monday,
                              [e.target.name]: e.target.value,
                            },
                          },
                        });
                      }}
                      options={SerializaeHours}
                      style={{ textAlign: "center" }}
                      errors={form.errors}
                    />
                  )}
                </td>
                <td>
                  {!form.details.schedule.monday.isClosed && (
                    <Select
                      label=""
                      variant="simple-no-label"
                      className="form-control form-input simple"
                      name="end"
                      value={form.details.schedule.monday.end}
                      onChangeOption={(e) =>
                        handleChangeForm({
                          ...form.details,
                          schedule: {
                            ...form.details.schedule,
                            monday: {
                              ...form.details.schedule.monday,
                              [e.target.name]: e.target.value,
                            },
                          },
                        })
                      }
                      options={SerializaeHours}
                      style={{ textAlign: "center" }}
                      errors={form.errors}
                    />
                  )}
                </td>
                <td className="text-center">
                  <Switch
                    label=""
                    name="isClosed"
                    value={form.details.schedule.monday.isClosed}
                    onChangeEvent={(e) =>
                      handleChangeForm({
                        ...form.details,
                        schedule: {
                          ...form.details.schedule,
                          monday: {
                            ...form.details.schedule.monday,
                            [e.target.name]: e.target.value,
                          },
                        },
                      })
                    }
                    style={{ textAlign: "center" }}
                    errors={form.errors}
                  />
                </td>
              </tr>
              <tr>
                <td>Terça-Feira </td>
                <td>
                  {!form.details.schedule.tuesday.isClosed && (
                    <Select
                      label=""
                      variant="simple-no-label"
                      className="form-control form-input simple"
                      name="start"
                      value={form.details.schedule.tuesday.start}
                      onChangeOption={(e) =>
                        handleChangeForm({
                          ...form.details,
                          schedule: {
                            ...form.details.schedule,
                            tuesday: {
                              ...form.details.schedule.tuesday,
                              [e.target.name]: e.target.value,
                            },
                          },
                        })
                      }
                      options={SerializaeHours}
                      style={{ textAlign: "center" }}
                      errors={form.errors}
                    />
                  )}
                </td>
                <td>
                  {!form.details.schedule.tuesday.isClosed && (
                    <Select
                      label=""
                      variant="simple-no-label"
                      className="form-control form-input simple"
                      name="end"
                      value={form.details.schedule.tuesday.end}
                      onChangeOption={(e) =>
                        handleChangeForm({
                          ...form.details,
                          schedule: {
                            ...form.details.schedule,
                            tuesday: {
                              ...form.details.schedule.tuesday,
                              [e.target.name]: e.target.value,
                            },
                          },
                        })
                      }
                      options={SerializaeHours}
                      style={{ textAlign: "center" }}
                      errors={form.errors}
                    />
                  )}
                </td>
                <td className="text-center">
                  <Switch
                    label=""
                    name="isClosed"
                    value={form.details.schedule.tuesday.isClosed}
                    onChangeEvent={(e) =>
                      handleChangeForm({
                        ...form.details,
                        schedule: {
                          ...form.details.schedule,
                          tuesday: {
                            ...form.details.schedule.tuesday,
                            [e.target.name]: e.target.value,
                          },
                        },
                      })
                    }
                    style={{ textAlign: "center" }}
                    errors={form.errors}
                  />
                </td>
              </tr>
              <tr>
                <td>Quarta-Feira </td>
                <td>
                  {!form.details.schedule.wednesday.isClosed && (
                    <Select
                      label=""
                      variant="simple-no-label"
                      className="form-control form-input simple"
                      name="start"
                      value={form.details.schedule.wednesday.start}
                      onChangeOption={(e) =>
                        handleChangeForm({
                          ...form.details,
                          schedule: {
                            ...form.details.schedule,
                            wednesday: {
                              ...form.details.schedule.wednesday,
                              [e.target.name]: e.target.value,
                            },
                          },
                        })
                      }
                      options={SerializaeHours}
                      style={{ textAlign: "center" }}
                      errors={form.errors}
                    />
                  )}
                </td>
                <td>
                  {!form.details.schedule.wednesday.isClosed && (
                    <Select
                      label=""
                      variant="simple-no-label"
                      className="form-control form-input simple"
                      name="end"
                      value={form.details.schedule.wednesday.end}
                      onChangeOption={(e) =>
                        handleChangeForm({
                          ...form.details,
                          schedule: {
                            ...form.details.schedule,
                            wednesday: {
                              ...form.details.schedule.wednesday,
                              [e.target.name]: e.target.value,
                            },
                          },
                        })
                      }
                      options={SerializaeHours}
                      style={{ textAlign: "center" }}
                      errors={form.errors}
                    />
                  )}
                </td>
                <td className="text-center">
                  <Switch
                    label=""
                    name="isClosed"
                    value={form.details.schedule.wednesday.isClosed}
                    onChangeEvent={(e) =>
                      handleChangeForm({
                        ...form.details,
                        schedule: {
                          ...form.details.schedule,
                          wednesday: {
                            ...form.details.schedule.wednesday,
                            [e.target.name]: e.target.value,
                          },
                        },
                      })
                    }
                    style={{ textAlign: "center" }}
                    errors={form.errors}
                  />
                </td>
              </tr>
              <tr>
                <td>Quinta-Feira </td>
                <td>
                  {!form.details.schedule.thursday.isClosed && (
                    <Select
                      label=""
                      variant="simple-no-label"
                      className="form-control form-input simple"
                      name="start"
                      value={form.details.schedule.thursday.start}
                      onChangeOption={(e) =>
                        handleChangeForm({
                          ...form.details,
                          schedule: {
                            ...form.details.schedule,
                            thursday: {
                              ...form.details.schedule.thursday,
                              [e.target.name]: e.target.value,
                            },
                          },
                        })
                      }
                      options={SerializaeHours}
                      style={{ textAlign: "center" }}
                      errors={form.errors}
                    />
                  )}
                </td>
                <td>
                  {!form.details.schedule.thursday.isClosed && (
                    <Select
                      label=""
                      variant="simple-no-label"
                      className="form-control form-input simple"
                      name="end"
                      value={form.details.schedule.thursday.end}
                      onChangeOption={(e) =>
                        handleChangeForm({
                          ...form.details,
                          schedule: {
                            ...form.details.schedule,
                            thursday: {
                              ...form.details.schedule.thursday,
                              [e.target.name]: e.target.value,
                            },
                          },
                        })
                      }
                      options={SerializaeHours}
                      style={{ textAlign: "center" }}
                      errors={form.errors}
                    />
                  )}
                </td>
                <td className="text-center">
                  <Switch
                    label=""
                    name="isClosed"
                    value={form.details.schedule.thursday.isClosed}
                    onChangeEvent={(e) =>
                      handleChangeForm({
                        ...form.details,
                        schedule: {
                          ...form.details.schedule,
                          thursday: {
                            ...form.details.schedule.thursday,
                            [e.target.name]: e.target.value,
                          },
                        },
                      })
                    }
                    style={{ textAlign: "center" }}
                    errors={form.errors}
                  />
                </td>
              </tr>
              <tr>
                <td>Sexta-Feira </td>
                <td>
                  {!form.details.schedule.friday.isClosed && (
                    <Select
                      label=""
                      variant="simple-no-label"
                      className="form-control form-input simple"
                      name="start"
                      value={form.details.schedule.friday.start}
                      onChangeOption={(e) =>
                        handleChangeForm({
                          ...form.details,
                          schedule: {
                            ...form.details.schedule,
                            friday: {
                              ...form.details.schedule.friday,
                              [e.target.name]: e.target.value,
                            },
                          },
                        })
                      }
                      options={SerializaeHours}
                      style={{ textAlign: "center" }}
                      errors={form.errors}
                    />
                  )}
                </td>
                <td>
                  {!form.details.schedule.friday.isClosed && (
                    <Select
                      label=""
                      variant="simple-no-label"
                      className="form-control form-input simple"
                      name="end"
                      value={form.details.schedule.friday.end}
                      onChangeOption={(e) =>
                        handleChangeForm({
                          ...form.details,
                          schedule: {
                            ...form.details.schedule,
                            friday: {
                              ...form.details.schedule.friday,
                              [e.target.name]: e.target.value,
                            },
                          },
                        })
                      }
                      options={SerializaeHours}
                      style={{ textAlign: "center" }}
                      errors={form.errors}
                    />
                  )}
                </td>
                <td className="text-center">
                  <Switch
                    label=""
                    name="isClosed"
                    value={form.details.schedule.friday.isClosed}
                    onChangeEvent={(e) =>
                      handleChangeForm({
                        ...form.details,
                        schedule: {
                          ...form.details.schedule,
                          friday: {
                            ...form.details.schedule.friday,
                            [e.target.name]: e.target.value,
                          },
                        },
                      })
                    }
                    style={{ textAlign: "center" }}
                    errors={form.errors}
                  />
                </td>
              </tr>
              <tr>
                <td>Sábado </td>
                <td>
                  {!form.details.schedule.saturday.isClosed && (
                    <Select
                      label=""
                      variant="simple-no-label"
                      className="form-control form-input simple"
                      name="start"
                      value={form.details.schedule.saturday.start}
                      onChangeOption={(e) =>
                        handleChangeForm({
                          ...form.details,
                          schedule: {
                            ...form.details.schedule,
                            saturday: {
                              ...form.details.schedule.saturday,
                              [e.target.name]: e.target.value,
                            },
                          },
                        })
                      }
                      options={SerializaeHours}
                      style={{ textAlign: "center" }}
                      errors={form.errors}
                    />
                  )}
                </td>
                <td>
                  {!form.details.schedule.saturday.isClosed && (
                    <Select
                      label=""
                      variant="simple-no-label"
                      className="form-control form-input simple"
                      name="end"
                      value={form.details.schedule.saturday.end}
                      onChangeOption={(e) =>
                        handleChangeForm({
                          ...form.details,
                          schedule: {
                            ...form.details.schedule,
                            saturday: {
                              ...form.details.schedule.saturday,
                              [e.target.name]: e.target.value,
                            },
                          },
                        })
                      }
                      options={SerializaeHours}
                      style={{ textAlign: "center" }}
                      errors={form.errors}
                    />
                  )}
                </td>
                <td className="text-center">
                  <Switch
                    label=""
                    name="isClosed"
                    value={form.details.schedule.saturday.isClosed}
                    onChangeEvent={(e) =>
                      handleChangeForm({
                        ...form.details,
                        schedule: {
                          ...form.details.schedule,
                          saturday: {
                            ...form.details.schedule.saturday,
                            [e.target.name]: e.target.value,
                          },
                        },
                      })
                    }
                    style={{ textAlign: "center" }}
                    errors={form.errors}
                  />
                </td>
              </tr>
              <tr>
                <td>Domingo </td>
                <td>
                  {!form.details.schedule.sunday.isClosed && (
                    <Select
                      label=""
                      variant="simple-no-label"
                      className="form-control form-input simple"
                      name="start"
                      value={form.details.schedule.sunday.start}
                      onChangeOption={(e) =>
                        handleChangeForm({
                          ...form.details,
                          schedule: {
                            ...form.details.schedule,
                            sunday: {
                              ...form.details.schedule.sunday,
                              [e.target.name]: e.target.value,
                            },
                          },
                        })
                      }
                      options={SerializaeHours}
                      style={{ textAlign: "center" }}
                      errors={form.errors}
                    />
                  )}
                </td>
                <td>
                  {!form.details.schedule.sunday.isClosed && (
                    <Select
                      label=""
                      variant="simple-no-label"
                      className="form-control form-input simple"
                      name="end"
                      value={form.details.schedule.sunday.end}
                      onChangeOption={(e) =>
                        handleChangeForm({
                          ...form.details,
                          schedule: {
                            ...form.details.schedule,
                            sunday: {
                              ...form.details.schedule.sunday,
                              [e.target.name]: e.target.value,
                            },
                          },
                        })
                      }
                      options={SerializaeHours}
                      style={{ textAlign: "center" }}
                      errors={form.errors}
                    />
                  )}
                </td>
                <td className="text-center">
                  <Switch
                    label=""
                    name="isClosed"
                    value={form.details.schedule.sunday.isClosed}
                    onChangeEvent={(e) => {
                      handleChangeForm({
                        ...form.details,
                        schedule: {
                          ...form.details.schedule,
                          sunday: {
                            ...form.details.schedule.sunday,
                            [e.target.name]: e.target.value,
                          },
                        },
                      });
                    }}
                    style={{ textAlign: "center" }}
                    errors={form.errors}
                  />
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
      <div className="row" style={{ marginTop: "30px" }}>
        <h3>Redes Sociais</h3>
      </div>
      <div className="row">
        <div className="col-12 col-sm-6">
          <label className="form-label">Instagram</label>
          <div className="input-group mb-3">
            <span className="input-group-text form-input" id="basic-addon1">
              www.instagram.com/
            </span>
            <input
              type="text"
              className="form-control form-input"
              placeholder="nightspotevents"
              value={form.details.link_instagram || ""}
              onPaste={(e) => { e.preventDefault(); handleChangeInputs({ target: { name: e.target.name, value: e.clipboardData.getData('Text') } }) }}
              onChange={(e) => handleChangeInputs(e)}
              name="link_instagram"
            />
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <label className="form-label">Facebook</label>
          <div className="input-group mb-3">
            <span className="input-group-text form-input" id="basic-addon1">
              www.facebook.com/
            </span>
            <input
              type="text"
              className="form-control form-input"
              placeholder="nightspotevents"
              value={form.details.link_facebook || ""}
              onPaste={(e) => { e.preventDefault(); handleChangeInputs({ target: { name: e.target.name, value: e.clipboardData.getData('Text') } }) }}
              onChange={(e) => handleChangeInputs(e)}
              name="link_facebook"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Details;
